import { Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/layouts/Header';
import Footer from './components/layouts/Footer';
import Home from './components/layouts/Home';
import AboutUs from './components/layouts/AboutUs';
import Festival from './components/layouts/Festival';
import News from './components/layouts/News';
import NewsDetail from './components/layouts/NewsDetail';
import Contact from './components/layouts/Contact';
import Teams from './components/layouts/Teams';
import Products from './components/layouts/Products';
import Gallery from './components/layouts/Gallery';
import AlbumDetail from './components/layouts/AlbumDetail';
import TeamsDetails from './components/layouts/TeamsDetails';
import NotFound from './components/layouts/NotFound';
import SakuraPetals from './components/layouts/SakuraPetals';
import ScrollToTop from './components/layouts/ScrollToTop';
import EmaWall from './components/layouts/EmaWall';
import Schedule from './components/layouts/Schedule';
import FestivalDetail from './components/layouts/FestivalDetail';

const App = () => (
    <HelmetProvider>
    <Router>
        <Fragment>
            <ScrollToTop />
            <SakuraPetals />
            <Header />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/about" component={AboutUs} />
                <Route exact path="/festival" component={Festival} />
                <Route exact path="/festival/:slug" component={FestivalDetail} />
                <Route exact path="/news" component={News} />
                <Route exact path="/news/:slug" component={NewsDetail} />
                <Route exact path="/ema" component={EmaWall} />
                <Route exact path="/schedule" component={Schedule} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/teams" component={Teams} />
                <Route exact path="/teams/:slug" component={TeamsDetails} />
                <Route exact path="/products" component={Products} />
                <Route exact path="/gallery" component={Gallery} />
                <Route exact path="/gallery/album/:id" component={AlbumDetail} />
                <Route render={() => <NotFound />} />
            </Switch>
            <Footer />
        </Fragment>
    </Router>
    </HelmetProvider>
);

export default App;
